import {PrimeReactProvider} from 'primereact/api';

export default function WpiReactApp( { Component, pageProps } ) {
	return (
		<PrimeReactProvider value={ { ripple: true } }>
			<Component { ...pageProps } />
		</PrimeReactProvider>
	);
}
